export default __webpack_public_path__ + "static/media/51.c8d241f2.jpg";